import React from 'react';
import { PreviewGenerationResult } from './previewGenerationResultData';
import EnsembleLinePreviewGroup from './EnsembleLinePreviewGroup';
import '../templateGeneration/previewGroup.scss';

interface Props {
    previewGroups: PreviewGenerationResult[];
    onJobItemSelected: (id: string[], isSelected: boolean) => void;
    selectedJobItems: string[];
    width: number;
    onTemplateNameChange: (uniqueIdentifier: string, newName: string) => void;

}

const PreviewGroupsBySourceDesign = ({
    previewGroups,
    onJobItemSelected,
    selectedJobItems,
    width,
    onTemplateNameChange,
}: Props): JSX.Element => {
    const handleNameChange = (uniqueIdentifier: string, newName: string): void => {
        onTemplateNameChange(uniqueIdentifier, newName);
    };

    return (
        <div className="composed-previews-overview-section">
            <div className="composed-previews-overview-container">
                {previewGroups.map((previewGroup) => (
                    <EnsembleLinePreviewGroup
                        key={previewGroup.uniqueIdentifier}
                        ensembleLine={previewGroup}
                        isSelected={selectedJobItems.includes(previewGroup.uniqueIdentifier as string)}
                        width={width}
                        onJobItemSelected={onJobItemSelected}
                        onTemplateNameChange={(newName: string): void => handleNameChange(previewGroup.uniqueIdentifier as string, newName)}
                    />
                ))}
            </div>
        </div>
    );
};

export default PreviewGroupsBySourceDesign;
